module.exports = __webpack_public_path__ + "assets/mam0.jpg?4a905c6d47d92df6bc0ad180e0b399ae";